export default "__VITE_ASSET__638b335e__"